import { BaseModel, RecursivePartial } from '@models/base';
import { MainMenuItem } from './main-menu-item';

export class MainMenu extends BaseModel {
    static readonly VER = 1;
    ver = MainMenu.VER;

    modified?: Date;
    items: MainMenuItem[] = [];

    constructor(json?: RecursivePartial<MainMenu>) {
        super(json);
        this.parseMainMenu(json || {});
    }

    parse(json: RecursivePartial<MainMenu>): MainMenu {
        super.parse(json);
        this.parseMainMenu(json);
        return this;
    }

    private parseMainMenu(json: RecursivePartial<MainMenu>): void {
        MainMenu.assignFields(this, json, ['ver']);
        MainMenu.assignDates(this, json, ['modified']);
        MainMenu.assignClassArrays(this, json, { items: MainMenuItem });
    }
}
